'use client';

import clsx from 'clsx';
import { FC } from 'react';
import { shallow } from 'zustand/shallow';

import { IconMenu } from 'src/general/Icons/IconMenu';
import { modalStore } from 'src/stores/modalStore';

import { Shade } from '../Shade/Shade';

export const InvestorHeaderMenuActionHamburger: FC = () => {
  const { openModal } = modalStore(
    (state) => ({
      openModal: state.openModal,
    }),
    shallow,
  );

  return (
    <button
      className={clsx(
        'c-shade_container relative flex h-10 cursor-pointer items-center justify-center gap-2 overflow-hidden rounded-full border border-bor-pri-lig px-1.5 transition-colors duration-200 mdp:hidden',
        // Styles override for the homepage
        'group-has-[.header-homepage]/body:group-[.scroll-top]/body:hover:bg-sta-on-inv-hov',
      )}
      onClick={() => openModal('mobileMenu')}
      title="Open menu"
    >
      <Shade noBackground />
      <IconMenu />
    </button>
  );
};
